export class Person {
  _id?: string;
  name: string = '';
  email: string = '';
  active: boolean = false;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/shared/person.model.ts